import GoogleMapReact, { Coords } from 'google-map-react'
import React from 'react'
import Marker from './Marker'

interface IProps extends Coords {
  label: string
}

function Map({ lat, lng, label }: IProps) {
  return (
    <div className="w-full h-60">
      <GoogleMapReact
        bootstrapURLKeys={{
          key: process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY!,
          libraries: ['places']
        }}
        defaultZoom={12}
        defaultCenter={{ lat, lng }}
      >
        <Marker lat={lat} lng={lng} label={label} />
      </GoogleMapReact>
    </div>
  )
}

export default Map
